import { BaseService } from "./BaseService";
import {
  CreateTenantUserDto,
  UserCreationResponse,
  UserFilterOptions,
  UserFilters,
} from "@/types/user";
import { UserProfile } from "@/types/user-profile";

export interface AdminUsersListResponse {
  items: UserProfile[];
  total: number;
  limit: number;
  offset: number;
}

class AdminUsersService extends BaseService {
  private readonly basePath = "/admin/users";

  getUsers(filters?: UserFilters): Promise<AdminUsersListResponse> {
    return this.get<AdminUsersListResponse>(this.basePath, filters, {
      skipSelectedHotelHeader: true,
    });
  }

  getUserFilterOptions(filters?: UserFilters): Promise<UserFilterOptions> {
    return this.get<UserFilterOptions>(
      `${this.basePath}/filter-options`,
      filters,
      {
        skipSelectedHotelHeader: true,
      },
    );
  }

  createTenantUser(
    tenantId: string,
    userData: CreateTenantUserDto,
  ): Promise<UserCreationResponse> {
    return this.post<UserCreationResponse>(
      this.basePath,
      { tenantId, ...userData },
      { skipSelectedHotelHeader: true },
    );
  }
}

export const adminUsersService = new AdminUsersService();
